import { CircleQuestionMarkIcon } from "lucide-react";

import { getText } from "shared/lib";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Button,
} from "shared/components";

export interface MeasurementEstimationAccordionProps {
  onClickSmall: () => void;
  onClickMedium: () => void;
  onClickLarge: () => void;
}

export function MeasurementEstimationAccordion({
  onClickLarge,
  onClickMedium,
  onClickSmall,
}: MeasurementEstimationAccordionProps) {
  return (
    <Accordion collapsible type="single">
      <AccordionItem value="tree-measurement">
        <AccordionTrigger className="text-bodysm text-textLink flex-none gap-1 underline [&_svg]:max-h-3 [&_svg]:max-w-3">
          <CircleQuestionMarkIcon /> {getText("How to measure a tree")}
        </AccordionTrigger>

        <AccordionContent className="flex flex-col gap-3">
          <p className="text-textSubdued text-bodysm">
            {getText(
              "If you can't measure the tree right now, you can use typical values for different tree sizes below. These are rough estimates. Measuring the tree yourself will improve the accuracy of your result.",
            )}
          </p>
          <ul className="marker:text-textLink list-inside list-disc pl-3">
            <li>
              <Button
                className="text-bodysm"
                onClick={onClickSmall}
                size="tight"
                variant="link"
              >
                {getText("Small")}
              </Button>{" "}
              ({getText("up to a couple of metres taller than a person")})
            </li>
            <li>
              <Button
                className="text-bodysm"
                onClick={onClickMedium}
                size="tight"
                variant="link"
              >
                {getText("Medium")}
              </Button>{" "}
              ({getText("as tall as a two-storey house")})
            </li>
            <li>
              <Button
                className="text-bodysm"
                onClick={onClickLarge}
                size="tight"
                variant="link"
              >
                {getText("Large")}
              </Button>{" "}
              ({getText("taller than a three-storey house")})
            </li>
          </ul>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
